<template>
  <div class="jd-finish">
    <w-nav-bar nav_title="今日推荐" icon=" "/>
    <div class="finish-container flex-column">
      <img src="https://files.wondercv.com/jobs/recommend-card-empty.png" alt="">
      <p class="description">您已经看完了所有推荐的职位<br>点击下方按钮查看更多职位</p>
      <button class="theme-button flex-center more-btn" @click="toJobs">更多职位</button>
    </div>
    <w-tab-bar page="job"/>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import WTabBar from '../../components/global/w-tabbar'

	export default {
		name: 'recommend-jd-card-finish',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WNavBar,
			WTabBar
		},
		methods: {
			toJobs () {
				this.$router.replace('/jobs/recommend')
      }
    }
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .jd-finish {
    min-height: 100vh;
    @include mobile-container(44px, 49px);
    .finish-container {
      align-items: center;
      img {
        width: 210px;
        margin-top: 72px;
        margin-bottom: 34px;
      }
      .description {
        color: $color-title;
        line-height: 24px;
        letter-spacing: 0.5px;
        text-align: center;
      }
      .more-btn {
        width: 260px;
        height: 38px;
        border-radius: 4px;
        font-size: $font-size-medium-x;
        margin-top: 70px;
      }
    }
  }
</style>
